import { Button, styled } from '@mui/material'
import { focusStyle } from '../../../../styles/common'

export const StyledButton = styled(({ small, ...rest }) => (
	<Button {...rest} />
))(({ theme, variant, small, position, align, disabled }) => ({
	'&.MuiButton-root': {
		fontFamily: 'Gotham',
		...(variant === 'text' && {
			'& .MuiButton-endIcon': {
				display: 'none'
			}
		}),
		borderRadius: '0.1875rem',
		minWidth: '10.0625rem', // 160px
		minHeight: '2.8125rem', // 45px
		textTransform: 'none',
		fontSize: '1rem',
		fontWeight: 400,
		...(small && {
			minWidth: '8.125rem', // 125px
			minHeight: '2.8125rem' // 45px
		}),
		[theme.breakpoints.up('md')]: {
			minWidth: '10.75rem',
			minHeight: '3.625rem',
			fontSize: '1rem',
			...(small && {
				minWidth: '8.125rem',
				minHeight: '2.8125rem'
			})
		},
		...(variant === 'contained' && {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.white,
			'&:hover, &:focus, &:active': {
				backgroundColor: '#ffffff',
				border: `1px solid ${theme.palette.primary.main}`,
				color: theme.palette.primary.main,
				'& .MuiButton-endIcon': {
					display: 'inherit'
				}
			},
			'& .MuiButton-endIcon': {
				display: 'none',
				transition: 'opacity 0.8s ease'
			}
		}),
		...(variant === 'outlined' && {
			borderColor: theme.palette.primary.main,
			color: theme.palette.primary.main,
			'&:hover, &:focus, &:active': {
				backgroundColor: theme.palette.primary.main,
				color: '#ffffff',
				'& .MuiButton-endIcon': {
					display: 'inherit'
				}
			},
			'& .MuiButton-endIcon': {
				display: 'none',
				transition: 'opacity 0.8s ease'
			}
		}),
		...(variant === 'text' && {
			color: theme.palette.primary.main,
			minWidth: 'unset!important',
			'&:hover': {
				backgroundColor: 'transparent',
				color: theme.palette.primary.main,
				textDecoration: 'underline'
			},
			'&:focus': {
				backgroundColor: 'transparent',
				color: theme.palette.primary.main,
				textDecoration: 'underline'
			},
			...focusStyle,
			'&:active': {
				backgroundColor: 'transparent',
				color: theme.palette.primary.main,
				textDecoration: 'underline'
			}
		}),
		...(disabled && {
			backgroundColor: theme.palette.primary.tint2
		}),
		...(position === 'left' && {
			alignSelf: 'flex-start'
		}),
		...(position === 'right' && {
			alignSelf: 'flex-end'
		}),
		...(position === 'center' && {
			alignSelf: 'center'
		}),
		...(align === 'left' && {
			marginRight: 'auto'
		}),
		...(align === 'right' && {
			marginLeft: 'auto'
		}),
		...(align === 'center' && {
			margin: '0 auto'
		})
	}
}))
